export const ApiDef_FlowSheet = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map